// client/src/pages/JoinPage.js

import React from 'react';

const JoinPage = () => {
  return (
    <>
      {/* Hero banner */}
      <section className="bg-primary text-white py-12 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-2">
          What If Retail Worked for Us?
        </h1>
        <p className="text-lg md:text-xl font-light">
          You’re not alone. It’s time to reclaim Main Street.
        </p>
      </section>

      {/* Main content */}
      <section className="bg-white px-6 py-16 md:px-20 text-deep-navy">
        <div className="max-w-4xl mx-auto prose prose-lg prose-h1:text-primary prose-h2:text-primary">
          <h2>This Is the Better Turns Movement</h2>
          <p>
            We’re a new kind of retail platform — one built <strong>for</strong>{' '}
            local stores, <strong>by</strong> local stores. No boardrooms. No
            private equity. No central command.
          </p>
          <blockquote>
            <p>
              <strong>
                Work together. Share data. Gain leverage. Stay independent.
              </strong>
            </p>
          </blockquote>

          <h2>What Makes Us Different</h2>
          <ul>
            <li>
              <strong>🛍 You Own Your Store</strong> – We don’t take over — we
              empower. You stay independent. Always.
            </li>
            <li>
              <strong>📊 We Share Intelligence</strong> – Tier 1 chains win with
              data. Now you can too.
            </li>
            <li>
              <strong>📦 We Buy Smarter Together</strong> – Vendor perks for
              small stores. Finally.
            </li>
            <li>
              <strong>🗺 We Plan as One</strong> – Co-op floor plans and shared
              strategies, minus the overhead.
            </li>
            <li>
              <strong>💸 We Split the Wins</strong> – Profits go back into local
              pockets — not shareholders.
            </li>
          </ul>

          <h2>Our Promise</h2>
          <p>
            We will never sell out. We will never consolidate ownership. We will
            never turn this into another faceless chain.
          </p>
          <p>
            This is about reclaiming retail — block by block, shelf by shelf,
            sale by sale.
          </p>

          <h2>The Time Is Now</h2>
          <p>If you’ve ever felt:</p>
          <ul>
            <li>Like you’re on your own</li>
            <li>Like the odds are stacked against you</li>
            <li>
              Like you’re being left behind by the tools, the prices, the
              systems...
            </li>
          </ul>
          <p>
            Then <em>you’re not alone</em>. And{' '}
            <strong>you’re exactly who this movement is for</strong>.
          </p>
          <blockquote>
            <p>
              That small businesses can compete — and win — when we stop playing
              their game and start building our own.
            </p>
          </blockquote>

          <h2>Let’s Build It Better, Together.</h2>
        </div>
      </section>

      {/* CTA footer */}
      <section className="bg-warm-orange text-white text-center py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          Ready to Join the Movement?
        </h2>
        <p className="text-lg mb-6 max-w-2xl mx-auto">
          We’re forming pilot stores, co-op buying teams, and strategic vendor
          relationships now.
        </p>
        <a
          href="/contact"
          className="inline-block bg-white text-warm-orange font-bold px-6 py-3 rounded shadow hover:bg-cool-gray transition"
        >
          Get Involved →
        </a>
      </section>
    </>
  );
};

export default JoinPage;
